export default {
  concedentes: [],
  concedente: {},
  pagination: {
    current_page: 1,
    per_page: 15,
  },
};
